export function formatTermLength(termLegnth: number): string {
  const termYear = termLegnth / 12
  return termYear > 1 ? `${termYear} Years` : `${termYear} Year`
}
